<h3 class="title-divider-suche">{{ heading | translate }}</h3>
<fieldset [doValidate]="!hasRightMassenabfrage" capTagebuchValidator>
  <cap-form-row column-classes="col-md-1,col-md-1">
    <cap-form-control column-classes="col-md-2,col-md-3" invalidKey="EingabeGrundbuchamtErforderlich" labelKey="Grundbuchamt">
      <cap-gb-amt
        (ngModelChange)="model && (model.grundbuchamtId = $event)"
        [hasfocus]="hasfocus"
        [ngModel]="model && model.grundbuchamtId"
        [searchMode]="searchMode"
        class="typeahead-holder"
        id="grundbuchamtId"
        name="grundbuchamt.grundbuchamtId">
      </cap-gb-amt>
      <button (click)="onReset()" class="btn btn-white" tabindex="-1" type="button">
        <span class="fas fa-times"></span>
      </button>
    </cap-form-control>

    <cap-form-control invalidKey="EingabeMussValideNummerSeinBeispiel" labelKey="Jahr">
      <input
        (blur)="onTouched()"
        (ngModelChange)="model && (model.jahr = $event)"
        [ngModel]="model && model.jahr"
        #tagebuchnummerJahr
        name="tagebuchnummer.jahr"
        size="10"
        type="text" />
    </cap-form-control>
    <cap-form-control invalidKey="EingabeMussValideNummerSein" labelKey="Nummer">
      <input
        (blur)="onTouched()"
        (ngModelChange)="model && (model.nummer = $event)"
        [ngModel]="model && model.nummer"
        name="tagebuchnummer.nummer"
        size="10"
        type="text" />
    </cap-form-control>
    <cap-form-control invalidKey="EingabeMussValideNummerSein" labelKey="Index">
      <input
        (blur)="onTouched()"
        (ngModelChange)="model && (model.index = $event)"
        [ngModel]="model && model.index"
        name="tagebuchnummer.index"
        size="10"
        type="text" />
    </cap-form-control>
  </cap-form-row>
</fieldset>
